module.exports = __webpack_public_path__ + "static/no-pet-10892a25ea8db02bd680bab00675b3c7.svg";